import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-package-details',
  templateUrl: './package-details.component.html',
  styleUrls: ['./package-details.component.scss']
})
export class PackageDetailsComponent implements OnInit {
  @Input() patientPackageDetails: any;

  constructor() { }

  ngOnInit(): void {
  }

  getPractitionerName(practitioners: any): string {
    if (!Array.isArray(practitioners) || practitioners.length === 0) {
      return 'N/A';
    }
    return practitioners.join(', ');
  }
  

}
